export default {
  namespaced: true,
  state: {
    // 用户信息
    info: {}
  },
  actions: {
    /**
     * @description 设置用户数据
     * @param {Object} context
     * @param {*} info info
     */
    set({
      state,
      dispatch
    }, info) {
      return new Promise(resolve => {
        // store 赋值
        state.info = info
        // 持久化
        dispatch('admin/db/set', {
          dbName: 'sys',
          path: 'user.info',
          value: info,
          user: true
        }, {
          root: true
        })
        // end
        resolve()
      })
    },
    /**
     * @description 从数据库取用户数据
     * @param {Object} context
     */
    load({
      state,
      dispatch
    }) {
      return new Promise(resolve => {
        // store 赋值
        dispatch('admin/db/get', {
          dbName: 'sys',
          path: 'user.info',
          defaultValue: {},
          user: true
        }, {
          root: true
        }).then(function (data) {
          state.info = data
        })


        // end
        resolve()
      })
    }
  }

}